import { useMutation } from '@tanstack/react-query'

import { aspidaClient } from '@/lib/aspida'
import { queryClient } from '@/lib/react-query'
import { MutationConfig } from '@/lib/react-query'

import { cartKeyFactory } from './key'

export const orderCart = () => {
  return aspidaClient.v1.cart.order.$patch()
}

type UseOrderCartOptions = {
  config?: MutationConfig<typeof orderCart>
}

export const useOrderCart = ({ config }: UseOrderCartOptions) => {
  return useMutation({
    onSuccess: () => queryClient.invalidateQueries(cartKeyFactory.all),
    ...config,
    mutationFn: orderCart,
  })
}
